import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IoMdMail } from "react-icons/io";
import { RiWhatsappFill } from "react-icons/ri";
import { IoLocation } from "react-icons/io5";
import { BiSolidPhoneCall } from "react-icons/bi";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from "../../assets/Frame 411.png";

const UserFooter = () => {
  const navigate = useNavigate();
  const [visitCount, setVisitCount] = useState(0);
  const currentYear = new Date().getFullYear();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Increment visit count when user loads website
    const addVisit = async () => {
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/visits/add-visit`);
        setVisitCount(res.data.count);
      } catch (err) {
        console.error("Error updating visit count:", err);
      }
    };

    addVisit();
  }, []);

  return (
    <React.Fragment>
      <footer className="bg-[#181818] text-white py-10 px-5 md:px-10">
        <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Description */}
          <div className="space-y-3 text-center">
            <p className="text-sm md:text-base tracking-wide text-justify">
              BBSR SERVICES - COMPANY REGISTRATION | ISO CERTIFICATION | GST REGISTRATION | FSSAI/ FOOD LICENCE | FIRM REG | PROPRIETOR | SMALL BUSINESS | INCOME TAX FILING | MSME | TM | TRADE | DRUG LICENCE | IMPORT EXPORT REGISTRATION | RCMC | OPC | LLP | FPO | TRUST REG | SOCIETY REG | NGO REG | MEDICAL DEVICES | FERTILIZER | ESIC | EPFO | LABOUR | AMPEDA | AEPC | BIS | BARCODE | DSC | PESTICIDE | CIVIL | MINING | NITI AAYOG | CSR | 80G | 12A | AUDIT REPORT | ACTIVITY REPORT | GST RETURN | ITR | TAX AUDIT | GEM | E-NAM |
            </p>
          </div>

          {/* Quick Links */}
          <div data-aos="flip-up" className="space-y-3 text-center">
            <h1 className="text-lg font-bold mb-1">
              <span className="pb-1 border-b-2 border-[#C0C0C0]">Quick Links</span>
            </h1>
            <div className="space-y-2">
              <div onClick={() => handleNavigation("/")} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">Home</div>
              <div onClick={() => handleNavigation("/about")} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">About Us</div>
              <div onClick={() => handleNavigation("/contact")} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">Contact Us</div>
              <div onClick={() => handleNavigation("/blog-list")} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">News & Blogs</div>
               <div onClick={() => handleNavigation("/our-service")} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">Our Service</div>
                <div onClick={() => handleNavigation("/all-article")} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">Article</div>
              {/* <div onClick={() => navigate("/service-details", { state: { serviceName: "Training" } })} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">Training</div>
              <div onClick={() => navigate("/service-details", { state: { serviceName: "Associates" } })} className="text-[#C0C0C0] cursor-pointer hover:text-white transition">Associates</div> */}
            </div>
          </div>

          {/* Contact */}
          <div data-aos="flip-down" className="space-y-3 text-center md:text-left">
            <h5 className="text-lg font-bold mb-1">
              <span className="pb-1 border-b-2 border-[#C0C0C0]">Contact Us</span>
            </h5>
            <div className="space-y-2">
              <div className="flex items-center justify-center md:justify-start">
                <BiSolidPhoneCall color="white" size={21} />
                <span className="ml-2">+91-7809477683</span>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <IoMdMail color="white" size={20} />
                <span className="ml-2">bbsrservices@gmail.com</span>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <IoLocation color="white" className="h-16 w-16 mt-[-10px]" />
                <span className="ml-2">
                  Plot No-587/588, Antaryami Niwas, Ground Floor Mahaveer Nagar,
                  Garage Chhak, Lewis Rd, Samantarapur, Bhubaneswar, Odisha 751002
                </span>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <IoLocation color="white" className="h-16 w-16 mt-[-10px]" />
                <span className="ml-2">
                  ADDRESS:1467 ,New Forest Park,Bhubaneswar ,Odisha,Pin: 751009 ,MAIL US:bbsrservices@gmail.com, website:www.bbsrservices.com .
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Footer Bottom */}
      <div className="bg-[#202020] text-white py-2 text-center text-sm">
        <div className="flex flex-col md:flex-row justify-center items-center">
          <div className="mb-2 md:mb-0 md:mr-4">Privacy Policy | Terms & Conditions</div>
          <div>
            <span>© {currentYear}, </span>
            <span className="text-yellow-600 font-semibold">BBSR Services &nbsp;|| &nbsp;</span>
            <span className="text-[#fe8740] cursor-pointer" onClick={() => window.open("https://webbocket.com/")}>
              Web_Bocket PVT LTD.
            </span>{" "}
            All Rights Reserved.
          </div>
        </div>

        {/* 👇 Show visit count here */}
        <div className="mt-2 text-gray-400 text-xs">
          Website Visits: <span className="text-white font-semibold">{visitCount}</span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserFooter;
